import { isEmptyText, Prismic } from '@landsbankinn/prismic';
import { Reveal, Segment } from '@landsbankinn/ui';
import React from 'react';
import { CardGroup } from '../components/card-group/CardGroup';
import { StaffCard } from '../components/card/StaffCard';
import { Heading } from '../components/slices/StaffWithBio';

interface IProps {
  fields: IField[];
  title: Prismic.RichText;
  three_per_line: boolean;
  id?: string;
}

interface IField {
  employee: IEmployee;
  show_image: boolean;
  percentage: number;
}

interface IEmployee {
  name: Prismic.RichText;
  title: Prismic.RichText;
  email: Prismic.RichText;
  phone: Prismic.RichText;
  image: Prismic.Image;
  location?: Prismic.RichText;
}

const CardItem = (
  {
    employee: { image, name, title, email, phone, location },
    show_image,
    percentage,
    ...rest
  }: IField,
  i: number,
) => {
  return (
    <StaffCard
      staffImage={image}
      name={Prismic.text(name)}
      title={Prismic.text(title)}
      location={Prismic.text(location) ?? undefined}
      email={Prismic.text(email)}
      phone={Prismic.text(phone)}
      hasImage={show_image !== false && !!image}
      percentage={percentage}
      {...rest}
    />
  );
};

export const StaffWithContactContainer = ({
  fields,
  title,
  id,
  three_per_line,
}: IProps) => {
  const items = fields?.filter(({ employee }) => employee !== null);
  if (items.length === 0) {
    return null;
  }

  const colCount = fields?.length;
  const columns = colCount <= 2 && three_per_line !== true ? 2 : 3;
  const imgSize = 1 / columns;

  return (
    <Segment id={id}>
      {!isEmptyText(title) && (
        <Reveal>
          <Heading>{Prismic.text(title)}</Heading>
        </Reveal>
      )}
      <CardGroup columns={columns}>
        {items?.map(({ percentage, ...rest }, index) => (
          <CardItem
            key={`staff-item-${index}-${Prismic.text(rest.employee.name)}`}
            percentage={imgSize}
            {...rest}
          />
        ))}
      </CardGroup>
    </Segment>
  );
};
